/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@brochure/globals';

import constants from '../../utils/constants';

const TrackedLink = ({
  children,
  href,
  domain,
  tealiumEvent,
  ...remainingProps
}) => {
  const domainValue = constants[domain];
  const urlRegex = /^https?:\/\/.*?(\/.*)?$/.exec(href);
  const path = urlRegex && urlRegex[1] ? urlRegex[1] : href;

  return (
    <Link
      path={path}
      domain={domainValue}
      tealiumEvent={tealiumEvent}
      {...remainingProps}
    >
      {children}
    </Link>
  );
};

TrackedLink.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  domain: PropTypes.string,
  tealiumEvent: PropTypes.string,
};

TrackedLink.defaultProps = {
  children: '',
  className: '',
  domain: 'appDomain',
  tealiumEvent: '',
};

export default TrackedLink;
